/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class Faculties<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Faculties
   * @name GetFacultiesList
   * @request GET:/Faculties/GetFaculties
   */
  getFacultiesList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Faculties/GetFaculties`,
      method: "GET",
      ...params,
    });
}
